import React from 'react';
import { Link } from 'react-router-dom';
import ImageUploader from 'react-images-upload';
import { connect } from 'react-redux';
import ReactLoading from 'react-loading';
import ReactDOM from 'react-dom';
import InputMask from 'react-input-mask';
import {
  Button
} from "react-bootstrap";
import { returnUrl } from '../../../helper/helperFunctions';

const defaultCompanyContacts = [
	{ name:'', phone:'', email: '', password: '', type:{'name':'Primary Contact'} },
	{ name:'', phone:'', email: '', type:{'name':'Accounting Contact'} },
	{ name:'', phone:'', email: '', type:{'name':'Other Contact'} }
];

class CompanyFormPage extends React.Component {
	constructor(props){
		super(props);
		const normalizedContacts = this.normalizeCompanyContacts(props.companyContactDataFP);
		this.state = {
			submitted 				: false,
			company 				: {
				name  				: this.props.companyDataFP.name      || '',
				address1 			: this.props.companyDataFP.address1  || '',
				address2 			: this.props.companyDataFP.address2  || '',
				city 				: this.props.companyDataFP.city      || '',
				state 				: this.props.companyDataFP.state     || '',
				zip					: this.props.companyDataFP.zip       || '',
				country 			: this.props.companyDataFP.country   || '',
				sales_rep			: this.props.companyDataFP.sales_rep || '',
				website				: this.props.companyDataFP.website   || '',
				price_per_adjudication : this.props.companyDataFP.price_per_adjudication || '',
				// price_per_group 	: this.props.companyDataFP.price_per_group || '',
				image 				: '',
				contact 			:{}
			},
			imagePreview:this.props.companyDataFP.image?this.props.companyDataFP.s3_baseurl+this.props.companyDataFP.image:'',
			companyContacts : normalizedContacts,
			companyContactsError:{
				Primary_Contact:{
					nameError:'', phoneError:'', emailError:'', passwordError:'',
				},
				Accounting_Contact:{
					nameError:'', phoneError:'', emailError:''
				},
				Other_Contact:{
					nameError:'', phoneError:'', emailError:''
				}
			},
			companyError : {
				nameError 					: '',
				address1Error 				: '',
				//address2Error 				: '',
				cityError 					: '',
				stateError 					: '',
				zipError					: '',
				countryError 				: '',
				sales_repError				: '',
				// websiteError				: '',
				price_per_adjudicationError 	: '',
				// price_per_groupError		: ''
			},
			companyFormType:this.props.formType,
			pictures:'',
			adminType: this.props.adminType,
			url: returnUrl('Companies', '')
		};

		this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleContactChange = this.handleContactChange.bind(this);
		this.onDrop = this.onDrop.bind(this);
	}

	normalizeCompanyContacts = (contacts) => {
		if (Array.isArray(contacts)) {
			return contacts;
		}
		if (contacts && typeof contacts === 'object') {
			const objectContacts = Object.values(contacts);
			if (objectContacts.length > 0) {
				return objectContacts;
			}
		}
		return defaultCompanyContacts;
	}

	onDrop(pictureFiles, pictureDataURLs) {

		const companyState = {...this.state.company};
      	companyState['image'] = pictureDataURLs[0];
      	this.setState({company: companyState});
        
    }


	handleChange(e) {
        const { name, value } = e.target;
        const companyState = {...this.state.company};
        companyState[name] = value;
        this.setState({company: companyState});
    }

    handleContactChange = (idx) => (evt) => {
		const normalizedContacts = this.normalizeCompanyContacts(this.state.companyContacts);
	    const newContact = normalizedContacts.map((contact, sidx) => {
	      if (idx !== sidx) return contact;
	      return { ...contact, [evt.target.name]: evt.target.value };
	    });
	    
	    this.setState({ companyContacts: newContact });
		
	}
	validateContact(){
		let   	isContactError = false;
		let 	contactErrors = {
			Primary_Contact:{nameError:'', phoneError:'', emailError:'', passwordError:''},
			Accounting_Contact:{nameError:'', phoneError:'', emailError:''},
			Other_Contact:{nameError:'', phoneError:'', emailError:''}
		};
		
		// console.log('contacts', this.state.companyContacts);
		// return false;
		Object.entries(this.state.companyContacts).map(([key, value]) => {
			var temp = value['type']['name'];

			if ( ((!value['name']) || value['name'].trim() === '')   && (temp !== 'Other Contact') ){
				isContactError = true;
				contactErrors[temp.replace(/\s+/g,"_")].nameError = 'Name is required.';
				var tempName = temp.replace(/\s+/g,"_")+'_name';
				ReactDOM.findDOMNode(this.refs[tempName]).focus();
			}

			if ( (temp === 'Primary Contact') && (value['password'] === '' || value['password'].trim() === '') && this.state.companyFormType === 'add'){
				isContactError = true;
				contactErrors[temp.replace(/\s+/g,"_")].passwordError = 'Password is required';
				var tempPass = temp.replace(/\s+/g,"_")+'_password';
				ReactDOM.findDOMNode(this.refs[tempPass]).focus();
			}
			if 	( ( (temp === 'Other Contact') && ((value['email']) && (!(value['email'].match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)))) ) ||
				  ( (temp !== 'Other Contact') && (!(value['email']) || (!(value['email'].match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)))) )	
				){
				isContactError = true;
				contactErrors[temp.replace(/\s+/g,"_")].emailError = temp === 'Other Contact'?'Email must be abc@example.com format.':'Email is required & must be abc@example.com format.';
				var tempEmail = temp.replace(/\s+/g,"_")+'_email';
				ReactDOM.findDOMNode(this.refs[tempEmail]).focus();
			}

			if 	( ( (temp === 'Other Contact') && ((value['phone']) && (!(value['phone'].match(/^((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/g)))) ) ||
				  ( (temp !== 'Other Contact') && (!(value['phone']) || (!(value['phone'].match(/^((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/g)))) )	
				){
				isContactError = true;
				contactErrors[temp.replace(/\s+/g,"_")].phoneError = temp === 'Other Contact'?'Phone must be 123-456-7890 format.':'Phone is required & format must be 123-456-7890.';
				var tempPhone = temp.replace(/\s+/g,"_")+'_phone';
				ReactDOM.findDOMNode(this.refs[tempPhone]).focus();
			}

		})

		this.setState({companyContactsError: contactErrors});
		
		return isContactError;
	}
    validate(){
    	let   isError = false;
    	const errorFocus = [];
    	const errors = {
    			nameError 					: '',
				address1Error 				: '',
				//address2Error 				: '',
				cityError 					: '',
				stateError 					: '',
				zipError					: '',
				countryError 				: '',
				sales_repError				: '',
				// websiteError				: '',
				price_per_adjudicationError 	: '',
				// price_per_groupError		: ''
    	};
    	if (this.state.company.name.length === 0 || this.state.company.name.trim() === '') {
      		isError = true;
      		errors.nameError = "Name is required.";
      		errorFocus.push('name');
    	}

    	if (this.state.company.address1.length === 0 || this.state.company.address1.trim() === '') {
      		isError = true;
      		errors.address1Error = "Adress 1 is required.";
      		errorFocus.push('address1');
    	}

    	if (this.state.company.city.length === 0 || this.state.company.city.trim() === '') {
      		isError = true;errors.cityError = "City is required.";
      		errorFocus.push('city');
    	}

    	if (this.state.company.state.length === 0 || this.state.company.state.trim() === '') {
      		isError = true;errors.stateError = "State is required.";
      		errorFocus.push('state');
    	}

    	if (this.state.company.zip.length === 0 || this.state.company.zip.trim() === '' || !(this.state.company.zip.match(/\d+/g)) ) {
      		isError = true;errors.zipError = "Zip is required & must be integer.";
      		errorFocus.push('zip');
    	}

    	if (this.state.company.country.length === 0 || this.state.company.country.trim() === '') {
      		isError = true;errors.countryError = "Country is required.";
      		errorFocus.push('country');
    	}

    	if (this.state.company.sales_rep.length === 0 || this.state.company.sales_rep.trim() === '') {
      		isError = true;
      		errors.sales_repError = "Sales Rep is required.";
      		errorFocus.push('sales_rep');
    	}

    	// if (this.state.company.website.length === 0 || !(this.state.company.website.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/g))) {
     //  		isError = true;
     //  		errors.websiteError = "Website is required & must be https://www.example.com format.";
     //  		errorFocus.push('website');
    	// }

    	if (this.state.company.price_per_adjudication === 0 || !(this.state.company.price_per_adjudication.match(/\d+/g)) ) {
      		isError = true;
      		errors.price_per_adjudicationError = "Price Per Adjudication is required & must be integer.";
      		errorFocus.push('price_per_adjudication');
    	}

    	// if (this.state.company.price_per_group === 0 || !(this.state.company.price_per_group.match(/\d+/g))) {
     //  		isError = true;
     //  		errors.price_per_groupError = "Price Per Group is required & must be integer.";
     //  		errorFocus.push('price_per_group');
    	// }

    	for (var i=errorFocus.length-1; i>=0; i--) {
    		ReactDOM.findDOMNode(this.refs[errorFocus[i]]).focus();
		}

    	this.setState({companyError: errors});
    	return isError;	
   		
  	};

  	handleSubmit(e) {
        e.preventDefault();
        this.setState({ submitted: true }, function(){
        	if (this.state.submitted) {
        		const conErr = this.validateContact();
	        	const err = this.validate();
		        if (!err && !conErr) {
			        const companyState = {...this.state.company};
			        companyState['contact'] = this.state.companyContacts;
			        this.setState({company: companyState}, function(){
			        	// console.log('Company information', this.state.company);
			        	this.props.handleActionParent(this.state.company);
			        });
		        } else {
		        	
		        }
	    	}
        });
        
    }
	render(){
		const { company, companyError, submitted, companyContactsError, adminType } = this.state;
		const { loading } = this.props;
		const companyContacts = this.normalizeCompanyContacts(this.state.companyContacts);
 		return(
			<div className="col-md-12">
				<form onSubmit={this.handleSubmit} encType="multipart/form-data">
					<div className="row">
						<div className="col-md-6">
							<div className={'form-group' + (submitted && companyError.nameError!=='' ? ' has-error' : '')}>
								<label htmlFor="name">Company Name</label>
								<input type="text" name="name" autoComplete="on" className="form-control" onChange={this.handleChange} value={company.name}  autoFocus={ companyError.nameError!==''?true:false } ref="name"/>
								{
									submitted && companyError.nameError!=='' &&
                            		<div className="help-block">{companyError.nameError}</div>
                        		}
							</div>
						</div>
						<div className="col-md-6">
							<div className={'form-group' + (submitted && companyError.address1Error!=='' ? ' has-error' : '')}>
								<label htmlFor="address1">Address 1</label>
								<input type="text" name="address1" autoComplete="on" ref="address1" className="form-control" onChange={this.handleChange} value={company.address1} autoFocus={ companyError.address1Error!==''?true:false }/>
								{
									submitted && companyError.address1Error!=='' &&
                            		<div className="help-block">{companyError.address1Error}</div>
                        		}
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col-md-6">
							<div className='form-group'>
								<label htmlFor="address1">Address 2</label>
								<input type="text" name="address2" autoComplete="on" ref="address2" className="form-control" onChange={this.handleChange} value={company.address2} />
								
							</div>
						</div>
						<div className="col-md-6">
							<div className={'form-group' + (submitted && companyError.cityError!=='' ? ' has-error' : '')}>
								<label htmlFor="city">City</label>
								<input type="text" name="city" ref="city" autoComplete="on" className="form-control" onChange={this.handleChange} value={company.city} />
								{
									submitted && companyError.cityError!=='' &&
                            		<div className="help-block">{companyError.cityError}</div>
                        		}
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col-md-6">
							<div className={'form-group' + (submitted && companyError.stateError!=='' ? ' has-error' : '')}>
								<label htmlFor="state">State</label>
								<input type="text" name="state" autoComplete="on" ref="state" className="form-control" onChange={this.handleChange} value={company.state} />
								{
									submitted && companyError.stateError!=='' &&
                            		<div className="help-block">{companyError.stateError}</div>
                        		}
							</div>
						</div>
						<div className="col-md-6">
							<div className={'form-group' + (submitted && companyError.zipError!=='' ? ' has-error' : '')}>
								<label htmlFor="zip">Zip</label>
								<input type="text" name="zip" autoComplete="on" ref="zip" className="form-control" onChange={this.handleChange} value={company.zip} />
								{
									submitted && companyError.zipError!=='' &&
                            		<div className="help-block">{companyError.zipError}</div>
                        		}
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col-md-6">
							<div className={'form-group' + (submitted && companyError.countryError!=='' ? ' has-error' : '')}>
								<label htmlFor="country">Country</label>
								<input type="text" name="country" autoComplete="on" ref="country" className="form-control" onChange={this.handleChange} value={company.country} />
								{
									submitted && companyError.countryError!=='' &&
                            		<div className="help-block">{companyError.countryError}</div>
                        		}
							</div>
						</div>
						<div className="col-md-6">
							<div className={'form-group' + (submitted && companyError.sales_repError!=='' ? ' has-error' : '')}>
								<label htmlFor="sales_rep">PhotoVision Sales Rep</label>
								<input type="text" name="sales_rep" autoComplete="on" ref="sales_rep" className="form-control" onChange={this.handleChange} value={company.sales_rep} readOnly={adminType === 'company' ? true : false} />
								{
									submitted && companyError.sales_repError!=='' &&
                            		<div className="help-block">{companyError.sales_repError}</div>
                        		}
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-md-6">
							<div className='form-group'>
								<label htmlFor="website">Website</label>
								<input type="text" name="website" autoComplete="on" ref="website" className="form-control" onChange={this.handleChange} value={company.website} />
								
							</div>
						</div>
						<div className="col-md-6">
							<div className={'form-group' + (submitted && companyError.price_per_adjudicationError!=='' ? ' has-error' : '')}>
								<label htmlFor="price_per_adjudication">Price per adjudication</label>
								<input type="text" name="price_per_adjudication" autoComplete="on" ref="price_per_adjudication" className="form-control dollar_icon" onChange={this.handleChange} value={company.price_per_adjudication} readOnly={adminType === 'company' ? true : false} />
								{
									submitted && companyError.price_per_adjudicationError!=='' &&
                            		<div className="help-block">{companyError.price_per_adjudicationError}</div>
                        		}
							</div>
						</div>
					</div>
					
					<div className="row">
					{
						/*

						<div className="col-md-6">
							<div className={'form-group' + (submitted && companyError.price_per_groupError!=='' ? ' has-error' : '')}>
								<label htmlFor="price_per_group">Price per group</label>
								<input type="text" name="price_per_group" autoComplete="on" ref="price_per_group" className="form-control dollar_icon" onChange={this.handleChange} value={company.price_per_group} readOnly={adminType === 'company' ? true : false} />
								{
									submitted && companyError.price_per_groupError!=='' &&
                            		<div className="help-block">{companyError.price_per_groupError}</div>
                        		}
							</div>
						</div>

						*/
					}
						<div className="col-md-6">
							<div className='form-group'>
								<label htmlFor="price_per_group">Image</label>

								<ImageUploader
					                withIcon={false}
					                buttonText='Choose image'
					                singleImage={true}
					                onChange={this.onDrop}
					                imgExtension={['.jpg', '.gif', '.png', '.gif']}
					                maxFileSize={5242880}
					                withPreview={true}
					                name='image'
					                label={'Choose Company Image'}
					                fileContainerStyle={{"padding":"0"}}
					                buttonClassName={company.image?'buttonHide':'buttonShow'}
					            />
								{
									this.state.companyFormType === 'edit' && this.state.imagePreview && !this.state.company.image &&
									<div className="fileUploader "> 
										<div className="fileContainer">
											<div className="uploadPicturesWrapper">
												<div className="imageUploadWrapper">
													<div className="uploadPictureContainer">
														<img src={this.state.imagePreview}  className="uploadPicture" alt="uploadpicture"/>
													</div>
												</div>
											</div>
										</div>
									</div>
								}
								
							</div>
						</div>
					</div>
						{
							companyContacts.map((contact, idx)=>(
								<div className="row" key={idx}>
									<h4>{contact.type.name}</h4>
									<div className="col-md-12">
										<div className="row">
											<div className="col-md-6">
												
												<div className={'form-group' + (submitted && companyContactsError[contact['type']['name'].replace(/\s+/g,"_")].nameError!=='' ? ' has-error' : '')}>
													<label htmlFor="name">Name</label>
													<input type="text" autoComplete="on" name="name" ref={contact['type']['name'].replace(/\s+/g,"_")+'_name'} className="form-control"  onChange={this.handleContactChange(idx)} value={contact.name?contact.name:''}  test1={idx} />
													{
														submitted && companyContactsError[contact['type']['name'].replace(/\s+/g,"_")].nameError!=='' &&
					                            		<div className="help-block">{companyContactsError[contact['type']['name'].replace(/\s+/g,"_")].nameError}</div>
					                        		}
												</div>
											</div>
											<div className="col-md-6">
												<div className={'form-group' + (submitted && companyContactsError[contact['type']['name'].replace(/\s+/g,"_")].phoneError!=='' ? ' has-error' : '')}>
													<label htmlFor="phone">Phone</label>
													

													<InputMask  autoComplete="on" mask="999-999-9999" maskChar={null} type="text" name="phone" ref={contact['type']['name'].replace(/\s+/g,"_")+'_phone'} value={contact.phone?contact.phone:''} placeholder="123-456-7890" className="form-control" test1={idx} onChange={this.handleContactChange(idx)} />
													{
														submitted && companyContactsError[contact['type']['name'].replace(/\s+/g,"_")].phoneError!=='' &&
					                            		<div className="help-block">{companyContactsError[contact['type']['name'].replace(/\s+/g,"_")].phoneError}</div>
					                        		}
												</div>
											</div>
										</div>
										<div className="row">	
											<div className="col-md-6">
												<div className={'form-group' + (submitted && companyContactsError[contact['type']['name'].replace(/\s+/g,"_")].emailError!=='' ? ' has-error' : '')}>
													<label htmlFor="email">Email</label>
													<input type="text" autoComplete="on" name="email" ref={contact['type']['name'].replace(/\s+/g,"_")+'_email'}  value={contact.email?contact.email:''} className="form-control" onChange={this.handleContactChange(idx)} />
													{
														submitted && companyContactsError[contact['type']['name'].replace(/\s+/g,"_")].emailError!=='' &&
					                            		<div className="help-block">{companyContactsError[contact['type']['name'].replace(/\s+/g,"_")].emailError}</div>
					                        		}
												</div>
											</div>
											{
												contact['type']['name'] === 'Primary Contact' &&
												<div className="col-md-6">
													<div className={'form-group' + (submitted && companyContactsError[contact['type']['name'].replace(/\s+/g,"_")].passwordError!=='' ? ' has-error' : '')}>
														<label htmlFor="password">Password</label>
														<input type="password" name="password" ref={contact['type']['name'].replace(/\s+/g,"_")+'_password'}  value={contact.password?contact.password:''} className="form-control" onChange={this.handleContactChange(idx)} minLength="6"/>
														{
															submitted && companyContactsError[contact['type']['name'].replace(/\s+/g,"_")].passwordError!=='' &&
						                            		<div className="help-block">{companyContactsError[contact['type']['name'].replace(/\s+/g,"_")].passwordError}</div>
						                        		}
													</div>
												</div>
											}
										</div>
									</div>
								</div>
							))
						}
					<div className="row">
						<div className="col-md-12">
							<div className='form-group'>

								{
									!loading &&
									<div className="btn-toolbar">
										<Button type='submit' bsSize="large" bsStyle="info" className="outOfTableButton" >Save</Button>
										<Link to={`/Admin/${this.state.url}?restore_page=true`}  className="btn btn-info btn-lg outOfTableButton">Cancel</Link>
										{/* <Link to={'/Admin/Companies?restore_page=true'}  className="btn btn-info btn-lg outOfTableButton">Cancel</Link> */}
									</div>
								}
								
								{ loading &&
									<ReactLoading type="bars" color="#1DC7EA" height={5} width={40} />	
								}
								
							</div>
						</div>
					</div>
				</form>
			</div>
		);
	};
}


function mapStateToProps(state) {
    const { loading } = state.companyReducer;
    
    return {
        loading
    };
}

const CompanyForm = connect(mapStateToProps)(CompanyFormPage);
export default CompanyForm;


// WEBPACK FOOTER //
// ./src/components/Admin/Company/CompanyForm.jsx